import { type LinearConfiguratorState } from "~/features/configurator/Linear/redux/types";
import { type PriceInfo } from "~/domains/pricing/api/PriceInfo";
import { sendConfiguratorAddToCart } from "~/features/configurator/common/api/configuratorCommandApi";

export function sendRailAddToCart(linearState: LinearConfiguratorState, priceInfo: PriceInfo | null): Promise<string> {
  return sendConfiguratorAddToCart(linearState, priceInfo);
}
